import * as React from 'react'
import {Form} from 'design-react-kit'
import GenericInput from 'src/frontend/app/components/GenericInput'
import {compilaIscrizioneOER} from 'src/processes/ProcessoIscrizione'
import {TokenStore} from 'src/keycloak/jwt/TokenStore'
import {getSoggettoByCfAndTipoAnagrafeFO} from 'src/processes/Soggetto'

export class FormIscrizioneOperatoreOER extends React.Component<GeneralFormIscrizioneOperatoreOERProps, any> {
  handleSubmit = async (event) => {
    /*--------------------------------------------- Validazione campi obbligatori ------------------------------------------------*/
    var error = { messaggio: 'Compila tutti i campi obbligatori', type: 'danger' }
    if (event.target.idEmailOperatoreOER.value === '') {
      event.preventDefault()
      return this.props.messaggio(error)
    } else {
      /*------------------------------------------------------------------------------------------------------------------------*/
      event.preventDefault()
      var parametriCompilazioneIscrizioneOER = {
        emailOperatoreOER: event.target.idEmailOperatoreOER.value ? event.target.idEmailOperatoreOER.value : '',
      }

      const token = TokenStore.getInstance().getDecodedTokenJWT()
      const fiscalNumber = token.spid_fiscalNumber
      const spidData: any = TokenStore.getInstance().getSpidData()

      var cf = spidData.codiceFiscale ? spidData.codiceFiscale : fiscalNumber
      var tipoAnagrafe = 'PF'

      getSoggettoByCfAndTipoAnagrafeFO(cf, tipoAnagrafe)
        .then((response: any) => {
          compilaIscrizioneOER(response.data.idSoggetto, parametriCompilazioneIscrizioneOER)
            .then((response) => {
              if (response.status === 200) return this.props.messaggio({ messaggio: 'Iscrizione avvenuta con successo', type: 'success' })
            })
            .catch(() => {
              return this.props.messaggio({ messaggio: "C'è stato un problema nell'invio dei dati", type: 'danger' })
            })
        })
        .catch(() => {
          return this.props.messaggio({ messaggio: "C'è stato durante il recupero dei dati", type: 'danger' })
        })
    }
  }

  render() {
    return (
      <div>
        <Form id={'idIscrizioneOperatoreOER'} onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col-6">
              <GenericInput type={'email'} id={'idEmailOperatoreOER'} placeholder={'Email di contatto'} label={'Email di contatto*'} isRequired />
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

export declare interface GeneralFormIscrizioneOperatoreOERProps {
  messaggio?: any
}
